export default {
  // 'menu.list.searchTable': '查询表格',
  // 'menu.gift.searchTable': '礼物列表',
  // 'searchTable.form.number': '集合编号',
  // 'searchTable.form.number.placeholder': '请输入集合编号',
  // 'searchTable.form.name': '集合名称',
  // 'searchTable.form.name.placeholder': '请输入集合名称',
  // 'searchTable.form.contentType': '内容体裁',
  // 'searchTable.form.contentType.img': '图文',
  // 'searchTable.form.contentType.horizontalVideo': '横版短视频',
  // 'searchTable.form.contentType.verticalVideo': '竖版小视频',
  // 'searchTable.form.filterType': '筛选方式',
  // 'searchTable.form.filterType.artificial': '人工筛选',
  // 'searchTable.form.filterType.rules': '规则筛选',
  // 'searchTable.form.createdTime': '创建时间',
  // 'searchTable.form.status': '状态',
  // 'searchTable.form.status.1': '已上线',
  // 'searchTable.form.status.0': '已下线',
  // 'searchTable.form.search': '查询',
  // 'searchTable.form.reset': '重置',
  // 'searchTable.form.selectDefault': '全部',
  // 'searchTable.operation.create': '新建',
  // 'searchTable.operation.import': '批量导入',
  // 'searchTable.operation.download': '下载',
  // // columns
  // 'searchTable.columns.id': '礼物编号',
  // 'searchTable.columns.name': '礼物名称',
  // 'searchTable.columns.price': '礼物价格',
  // 'searchTable.columns.image': '礼物图片',
  // 'searchTable.columns.status': '状态',
  // 'searchTable.columns.operations': '操作',
  // 'searchTable.columns.operations.view': '查看',

  'user.is_freeze.1': '冻结',
  'user.is_freeze.0': '正常',
};
